var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.687,
    height: 11.695,
    viewBox: "0 0 6.687 11.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85496",
    "data-name": "Group 85496",
    transform: "translate(63 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.037,15.917l4.422-4.425a.832.832,0,0,1,1.18,0,.843.843,0,0,1,0,1.184l-5.01,5.014a.834.834,0,0,1-1.153.024L6.431,12.679A.836.836,0,1,1,7.612,11.5Z",
    transform: "translate(-45.066 -41.188) rotate(90)",
    fill: "#fd930d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f23dd681a208099eab046d287a1007e3.svg";
export { ForwardRef as ReactComponent };